import React from 'react';

export const LeftArrowIcon = props => (
  <svg
    {...props}
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28 17L20 25L28 33"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RightArrowIcon = props => (
  <svg
    {...props}
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 33L30 25L22 17"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlayIcon = props => (
  <svg
    {...props}
    viewBox="5 0 23 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.525 13.4167L4.525 0.410497C2.7375 -0.645753 0 0.379247 0 2.99175V28.998C0 31.3417 2.54375 32.7542 4.525 31.5792L26.525 18.5792C28.4875 17.423 28.4937 14.573 26.525 13.4167Z"
      fill="currentColor"
    />
  </svg>
);

export const PauseIcon = props => (
  <svg
    {...props}
    viewBox="0 0 23 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75 30H2.25C1.00781 30 0 28.5603 0 26.7857V3.21429C0 1.43973 1.00781 0 2.25 0H6.75C7.99219 0 9 1.43973 9 3.21429V26.7857C9 28.5603 7.99219 30 6.75 30ZM23 26.7857V3.21429C23 1.43973 21.9922 0 20.75 0H16.25C15.0078 0 14 1.43973 14 3.21429V26.7857C14 28.5603 15.0078 30 16.25 30H20.75C21.9922 30 23 28.5603 23 26.7857Z"
      fill="currentColor"
    />
  </svg>
);
